function player(video: HTMLVideoElement): void {
    // If the video is not ready
    if (video.readyState == 0) {
        console.error(
            'The video could not be loaded, either because the server or network failed or because the format is not supported.',
        );
        return;
    }

    // If the video paused or ended
    if (video.paused || video.ended) {
        void video.play();
    }
    // If the video played
    else {
        video.pause();
    }
}

function stop(video: HTMLVideoElement): void {
    video.pause();
    video.currentTime = 0;
}

// ----------------------------------------------------------------------------

function fastBackward(video: HTMLVideoElement): void {
    video.currentTime = 0;
}

function fastForward(video: HTMLVideoElement): void {
    video.currentTime = video.duration;
}

function stepBackward(video: HTMLVideoElement, fps = 4): void {
    video.currentTime = Math.max(0, video.currentTime - fps);
}

function stepForward(video: HTMLVideoElement, fps = 4): void {
    video.currentTime = Math.min(video.duration, video.currentTime + fps);
}

// ----------------------------------------------------------------------------

const controller = {
    fastBackward,
    fastForward,
    player,
    stepBackward,
    stepForward,
    stop,
};

export { controller, fastBackward, fastForward, player, stepBackward, stepForward, stop };
